export class ProductGradeReportReq {
    poFromDate ?:string
    poToDate ?:string
    product?:string
    grade?:string
    buyerId?:number
    countryId?:number
    productId?:number
    foodType?:number
    valAdd1?:number
    valAdd2?:number
    valAdd3?:number
    valAdd4?:number
    valAdd5?:number

    constructor(
        poFromDate ?:string,
        poToDate ?:string,
        product?:string,
        grade?:string,
        buyerId?:number,
        countryId?:number,
        productId?:number,
    foodType?:number,
    valAdd1?:number,
    valAdd2?:number,
    valAdd3?:number,
    valAdd4?:number,
    valAdd5?:number
    ){
        this.grade = grade
        this.poFromDate = poFromDate
        this.poToDate = poToDate
        this.product = product
        this.buyerId = buyerId
        this.countryId = countryId
        this.foodType = foodType
        this.valAdd1 = valAdd1
        this.valAdd2 = valAdd2 
        this.valAdd3 = valAdd3
        this.valAdd4 = valAdd4
        this.valAdd5 = valAdd5
    }

}